import { render, staticRenderFns } from "./MBScan.vue?vue&type=template&id=e4b16068&"
import script from "./MBScan.vue?vue&type=script&lang=js&"
export * from "./MBScan.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports